const states = [
    { Id: 0, Name: "Новая" },
    { Id: 1, Name: "В обработке" },
    { Id: 2, Name: "Обработана" }
];

export default states;


// WEBPACK FOOTER //
// ./src/constants/callbackStates.js